import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=0a9957e1&scoped=true&"
import script from "./PhoneInput.vue?vue&type=script&lang=js&"
export * from "./PhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=0a9957e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9957e1",
  null
  
)

export default component.exports